var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEazyAudit = function SvgEazyAudit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 67"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.16,
    cy: 33.658,
    r: 33.26,
    fill: "#204969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFF4",
    fillRule: "evenodd",
    d: "M27.652 46.13a5.13 5.13 0 0 1-5.133-5.126V26.311a5.13 5.13 0 0 1 5.133-5.125h12.185a5.13 5.13 0 0 1 5.133 5.125v14.693q-.002.75-.206 1.438c-.058.2-.314.247-.453.087l-2.655-3.033a6.8 6.8 0 0 0 1.548-4.326c0-3.804-3.116-6.873-6.938-6.873s-6.94 3.07-6.94 6.873 3.115 6.872 6.94 6.872a6.96 6.96 0 0 0 4.057-1.298l3.11 3.557a.27.27 0 0 1-.01.37 5.12 5.12 0 0 1-3.585 1.46zm3.5-10.96c0-2.78 2.28-5.046 5.114-5.046s5.11 2.266 5.11 5.047-2.28 5.047-5.11 5.047-5.114-2.27-5.114-5.047",
    clipRule: "evenodd"
  })));
};
export default SvgEazyAudit;